<template>
  <div class="pageDiv">
    <v-card class="main-card" v-if="!$AuthSvc.isLogin()">
      <v-card-title style="padding-bottom:0">
        <span class="page-title">Schedule Edit Admin</span>
      </v-card-title>
      Must login to view data
    </v-card>

    <v-card class="main-card" v-if="$AuthSvc.isLogin()">
      <v-card-title style="padding-bottom:0">
        <span class="page-title">Schedule Edit Admin</span>
      </v-card-title>

      <v-card v-if="course!==null" class="course-card">
        <div class="course-item">
          <div>
            <span>Format: </span>
            <select class="dropdown" v-model="tournament.formatType">
              <option value="TOURNAMENT">TOURNAMENT</option>
              <option value="CUP">CUP</option>
              <option value="FUN">FUN</option>
              <option value="BANQUET">BANQUET</option>
            </select>
          </div>
          <div>
            <span>Sponsor:</span> <input class="sponsor-name" v-model="tournament.sponsorName"/>
          </div>
          <div>
            <span>Course Name: </span> {{course===null?'':course.name}}
          </div>
          <div>
            <span>Location: </span> {{course===null?'':course.location}}
          </div>
          <div>
            <span>Website: </span> {{course===null?'':course.website}}
          </div>
          <div>
            <span>Is a Major? </span> <input class="checkbox" type="checkbox" v-model="major"/>
          </div>
          <div>
            <span>Is Shotgun? </span> <input class="checkbox" type="checkbox" v-model="shotgun"/>
          </div>
          <div>
            <span>Is Single Match? </span> <input class="checkbox" type="checkbox" v-model="singleMatch"/>
          </div>
          <div>
            <span>Is Team Match? </span> <input class="checkbox" type="checkbox" v-model="teamMatch"/>
          </div>
          <div>
            <span>19th Hole:</span> <textarea class="text-area editMessageText" rows="4" v-model="tournament.hole19"/>
          </div>
        </div>

        <div class="course-item">
          <div>
            <span>Date Time: </span> <input type="datetime-local" v-model="scheduleDate"/>
          </div>
          <div>
            <span>Early Ends: </span> <input type="datetime-local" v-model="earlyRegister"/>
          </div>
          <div>
            <span>Deadline: </span> <input type="datetime-local" v-model="deadline"/>
          </div>
          <div>
            <span>Member Fee: $</span> <input class="dfwvga-btn" v-model="tournament.memberFee"/>
          </div>
          <div>
            <span>Guest Fee: $</span> <input class="dfwvga-btn" v-model="tournament.guestFee"/>
          </div>
          <div>
            <span>Junior Fee: $</span> <input class="dfwvga-btn" v-model="tournament.juniorFee"/>
          </div>
          <div>
            <span>Format: </span>
            <select class="dropdown" v-model="tournament.status">
              <option value="PLANNED">PLANNED</option>
              <option value="REGISTER">REGISTER</option>
              <option value="REGISTER_COMPLETED">REGISTER_COMPLETED</option>
              <option value="GROUPING">GROUPING</option>
              <option value="ACTIVE">ACTIVE</option>
              <option value="REVIEW">REVIEW</option>
              <option value="OFFICIAL">OFFICIAL</option>
              <option value="CLOSE">CLOSE</option>
            </select>
          </div>
          <div>
            <span>Course Id: </span> <input class="dfwvga-btn" v-model="tournament.courseId"/>
          </div>
          <div>
            <span>Limit: </span> <input class="dfwvga-btn" v-model="tournament.limitSize"/>
          </div>
          <div>
            <span>Home Team: </span> <input class="dfwvga-btn" v-model="tournament.homeTeam"/>
          </div>
          <div>
            <span>Away Team: </span> <input class="dfwvga-btn" v-model="tournament.awayTeam"/>
          </div>
        </div>

        <div>
          <v-card-text>
            <span class="label16">Itinerary</span>
            <textarea class="textareaMessage editMessageText" v-model="tournament.itinerary"></textarea>
            <br><br>
            <span class="label16">Winner Message</span>
            <textarea class="textareaMessage editMessageText" v-model="tournament.winnerMessage"></textarea>
          </v-card-text>
        </div>

        <div style="display:inline-block;width:100%;">
          <v-btn class="add-button" @click="saveSchedule()">Save</v-btn>
          <v-btn class="add-button" @click="cancel()">Cancel</v-btn>
        </div>
      </v-card>
    </v-card>

  </div>

</template>

<script>
  import moment from 'moment';
  
    export default {
      name: "scheduleEdit",
      data: () => ({
        tournament: null,
        course: null,
        scheduleDate: null,
        deadline: null,
        earlyRegister: null,
        major: false,
        shotgun: false,
        singleMatch: false,
        teamMatch: false
      }),
      mounted: function() {
          var _this = this;
          _this.loadSchedule();
      },
      methods: {
        loadSchedule() {
            var _this = this;
  
            const urlParams = new URLSearchParams(window.location.search);
            const tournamentId = urlParams.get('tournamentId')
            const courseId = urlParams.get('courseId')
  
            if (tournamentId === '0') {
              _this.scheduleDate = moment().set({ hour: 8, minute: 0 }).format('YYYY-MM-DDTHH:mm');
              _this.deadline = moment().set({ hour: 23, minute: 59 }).format('YYYY-MM-DDTHH:mm');
              _this.earlyRegister = moment().set({ hour: 23, minute: 59 }).format('YYYY-MM-DDTHH:mm');
  
              this.tournament = {
                formatType: 'TOURNAMENT',
                active: 'N',
                shotgun: 'N',
                singleMatch: 'N',
                teamMatch: 'N',
                major: 'N',
                courseId: courseId,
                year: this.$AuthSvc.getYear(),
                sponsorName: '',
                scheduleDate: _this.scheduleDate,
                memberFee: '',
                teeBox: '',
                limitSize: '0',
                courseYardage: '',
                nicklausCtp: '',
                palmerCtp: '',
                registrationDeadline: _this.deadline,
                earlyRegisterDeadline: _this.earlyRegister,
                status: 'PLANNED',
                comment: '',
                file: null,
                sponsor: null,
                isBusy: false
              };
  
              _this.axios.get('/public/courses/' + courseId)
              .then(function (response) {
                _this.course = response.data;
  
              })
              .catch(function (error) {
                  console.log('ERROR: ' + error);
              });
            }
            else {
              _this.axios.get('/public/tournaments/' + tournamentId)
              .then(function (response) {
                  _this.tournament = response.data;
  
                  var schedDate = moment(_this.tournament.scheduleDate).format('YYYY-MM-DDTHH:mm');
                  var deadline = moment(_this.tournament.registrationDeadline).format('YYYY-MM-DDTHH:mm');
                  var earlyRegister = moment(_this.tournament.earlyRegisterDeadline).format('YYYY-MM-DDTHH:mm');
  
                  _this.scheduleDate = schedDate;
                  _this.deadline = deadline;
                  _this.earlyRegister = earlyRegister;
                  _this.major = _this.tournament.major === 'Y';
                  _this.shotgun = _this.tournament.shotgun === 'Y';
                  _this.singleMatch = _this.tournament.singleMatch === 'Y';
                  _this.teamMatch = _this.tournament.teamMatch === 'Y';
  
                  _this.axios.get('/public/courses/' + _this.tournament.courseId)
                  .then(function (response) {
                    _this.course = response.data;
  
                  })
                  .catch(function (error) {
                      console.log('ERROR: ' + error);
                  });
  
              })
              .catch(function (error) {
                  console.log('ERROR: ' + error);
              });
            }
  
  
        },
        cancel() {
          window.location.href = '/schedule-admin';
        },
        // isDST(d) {
        //     let jan = new Date(d.getFullYear(), 0, 1).getTimezoneOffset();
        //     let jul = new Date(d.getFullYear(), 6, 1).getTimezoneOffset();
        //     return Math.max(jan, jul) !== d.getTimezoneOffset();    
        // },
        saveSchedule() {
          var _this = this;
  
          _this.tournament.scheduleDate = _this.scheduleDate + ':00.000-06:00';
          _this.tournament.registrationDeadline = _this.deadline + ':00.000-06:00';
          _this.tournament.earlyRegisterDeadline = _this.earlyRegister + ':00.000-06:00';
  
          _this.tournament.major = _this.major ? 'Y' : 'N';
          _this.tournament.shotgun = _this.shotgun ? 'Y' : 'N';
          _this.tournament.singleMatch = _this.singleMatch ? 'Y' : 'N';
          _this.tournament.teamMatch = _this.teamMatch ? 'Y' : 'N';
  
          _this.axios.post('/api/tournaments', _this.tournament)
          .then(function (response) {
              console.log('SAVE Tournament Successful ' + response.data);
              window.location.href = '/schedule-admin';
          })
          .catch(function (error) {
              console.log('ERROR: ' + error);
          });
        }
      }
    }

</script>

<style scoped>
  .main-card {
      margin: 10px;
  }

  button {
    margin-left: 15px;
  }

  input {
    width: 300px;
    height: 32px;
  }

  .dfwvga-btn {
    width: 200px !important;
  }

  .dropdown {
    width: 200px !important;
  }

  .course-card {
    padding: 20px;
    margin-top: 20px;
  }

  .course-item > div {
    display: inline-block;
    margin-bottom: 7px;
    width: 100% !important;
  }

  .course-item > div > span {
    display: inline-block;
    float: left;
    width: 120px;
    font-size: 14px;
    font-weight: bold;
  }

  .checkbox {
    display: inline-block;
    float: left;
    width: 20px;
    height: 20px;
  }

  .tournament-card {
    background-color: #D6DADA !important;
    margin: 10px 0;
    padding: 12px;
  }

  .course-item {
    display: inline-block;
    padding: 10px;
    height: auto;
    margin-bottom: 7px;
    vertical-align: top;
  }

  .text-area {
    width: 100%;
    padding: 10px;
    background-color: white;
    border: 1px solid;
    border-radius: 5px;
    margin-top: 5px;
  }

  .sponsor-name {
    width: 320px !important;
    background-color: white;
    border: 1px solid;
    border-radius: 5px;
    padding: 3px 5px !important;
  }

  .textareaMessage {
    width: 100%;
    height: 400px;
    padding: 12px 20px;
    box-sizing: border-box;
    border: 2px solid #ccc;
    border-radius: 4px;
    background-color: #f8f8f8;
  }

  @media (min-width: 768px) {
      .course-item {
        width: 400px !important;
      }
  }
</style>